import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Header,
    Form,
    Button,
    Segment,
    Icon,
    Radio,
    Divider } from 'semantic-ui-react';
import { api } from '../../../services/api';
import { isAdmin } from "../../../services/auth";

import Sidebar from '../../../components/Sidebar';
import Navbarr from '../../../components/Navbar';

import './styles.css';

const roleOptions = [
    { key: 'ROLE_ADMIN', value: 'ROLE_ADMIN', text: 'Administrador'},
    { key: 'ROLE_USUARIO', value: 'ROLE_USUARIO', text: 'Promotor'}
]

export default function UserCreate() {
    const [userStates, setUserStates] = useState({
        formUser: {
            email: '',
            nome: '',
            senha: '',
            role: '',
            status: ''
        },
        isLoading: false
    });

    const resetUserStates = () => {
        setUserStates( state => ({
            ...state,
            formUser: {
                email: '',
                nome: '',
                role: '',
                status: '',
                senha: ''
            },
            isLoading: false
        }));
    }

    const handleNomeChange = (e, {value}) => {
        setUserStates( state => ({
            ...state,
            formUser: {
                ...state['formUser'],
                nome: value
            }
        }));
    }

    const handleEmailChange = (e, {value}) => {
        setUserStates( state => ({
            ...state,
            formUser: {
                ...state['formUser'],
                email: value
            }
        }));
    }

    const handleRoleChange = (e, {value}) => {
        setUserStates( state => ({
            ...state,
            formUser: {
                ...state['formUser'],
                role: value
            }
        }));
    }

    const handleStatusChange = (e, {value}) => {
        setUserStates( state => ({
            ...state,
            formUser: {
                ...state['formUser'],
                status: value
            }
        }));
    }

    const handleSenhaChange = (e, {value}) => {
        setUserStates( state => ({
            ...state,
            formUser: {
                ...state['formUser'],
                senha: value
            }
        }));
    }

    /*const goToUserEditScreen = (e, user, index) => {

    }*/

    async function handlePost() {
        try {
            setUserStates( state => ({
                ...state,
                isLoading: true,
            }));
            /*const data =*/ await api.postUser(...Object.values(userStates['formUser']));
            Alert.success("Usuário cadastrado com sucesso!");
            resetUserStates();
        } catch (err) {
            Alert.error("Falha ao cadastrar usuário. Verifique os campos e tente novamente.");
            console.error('Falha ao criar usuário: ', err);
            setUserStates( state=> ({
                ...state,
                isLoading: false,
            }));
        }
    }

    if (isAdmin()) {
        return (
            <Container className="u-content">
                <Side style={{flex: '0 0 auto', width: 'auto'}}>
                    <Sidebar page={"usernew"}></Sidebar>
                </Side>
                <Container>
                    <HeaderRS>
                        <Navbarr></Navbarr>
                    </HeaderRS>
                    <Content style={{ backgroundColor: '#FAFAFA', padding: '5px'}}>
                        <div>
                            <Segment
                                loading={userStates['isLoading']}
                                style={{ boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' }}
                                >
                                <Header as='h3' floated='left'>
                                    Novo Usuário
                                </Header>

                                <Divider clearing />
                                Preencha os campos com as informações do usuário
                                <Form style={{marginTop: '15px'}}>
                                    <Form.Group inline>
                                            <label>Status</label>
                                            <Form.Field
                                                control={Radio}
                                                label='Ativo'
                                                value='ATIVO'
                                                checked={userStates['formUser'] &&
                                                    userStates['formUser']['status'] === 'ATIVO' ?
                                                    true : false}
                                                onChange={handleStatusChange}
                                            />
                                            <Form.Field
                                                control={Radio}
                                                label='Inativo'
                                                value='INATIVO'
                                                checked={userStates['formUser'] &&
                                                    userStates['formUser']['status'] === 'INATIVO' ?
                                                    true : false}
                                                onChange={handleStatusChange}
                                            />
                                        </Form.Group>

                                        <Form.Group widths='equal'>
                                            <Form.Input
                                                iconPosition='left'
                                                icon='mail'
                                                fluid label='Email'
                                                placeholder='Email'
                                                value={userStates['formUser'] ?
                                                    userStates['formUser']['email']: ""}
                                                onChange={handleEmailChange}
                                            />
                                            <Form.Input
                                                iconPosition='left'
                                                icon='user'
                                                fluid label='Nome'
                                                placeholder='Nome'
                                                value={userStates['formUser'] ?
                                                    userStates['formUser']['nome']: ""}
                                                onChange={handleNomeChange}
                                            />
                                        </Form.Group>

                                        <Form.Group widths='equal'>
                                            <Form.Select
                                                fluid label='Papel'
                                                options={roleOptions}
                                                value={userStates['formUser'] ?
                                                    userStates['formUser']['role'] : ""}
                                                placeholder='Status'
                                                onChange={handleRoleChange}
                                            />
                                            <Form.Input
                                                iconPosition='left'
                                                icon='lock'
                                                fluid label='Senha'
                                                placeholder='Senha'
                                                type='password'
                                                value={userStates['formUser'] ?
                                                    userStates['formUser']['senha']: ""}
                                                onChange={handleSenhaChange}
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <Button
                                                style={{marginLeft: '7px', marginTop: '7px'}}
                                                primary
                                                size="mini"
                                                floated='right'
                                                onClick={handlePost}
                                                type='submit'>
                                                    <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                        <Icon name='save'/> Salvar
                                                    </div>
                                            </Button>
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </div>
                        </Content>
                    <Footer></Footer>
                </Container>
            </Container>
        );
    } else {
        return ( <Redirect to="/dashboard" /> );
    }
}
